<template>
    <footer class="footer">
        <div class="container-fluid text-center text-white">
            <brand-footer :show-version="true"></brand-footer>
        </div>
    </footer>
</template>

<script>
    export default {
    }
</script>
